module.exports = __webpack_public_path__ + "img/alarm3.499b16da.svg";